// JsFromRoutes CacheKey fc54217e95eb99a8b45bcdcc9a84325b
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@consumer/services/api'

export default {
  places: /* #__PURE__ */ definePathHelper('get', '/consumer/gift_recommendations/places'),
  pin: /* #__PURE__ */ definePathHelper('post', '/consumer/gift_recommendations/pin'),
  unpin: /* #__PURE__ */ definePathHelper('delete', '/consumer/gift_recommendations/pin'),
  hide: /* #__PURE__ */ definePathHelper('post', '/consumer/gift_recommendations/hide'),
  unhide: /* #__PURE__ */ definePathHelper('delete', '/consumer/gift_recommendations/hide'),
  index: /* #__PURE__ */ definePathHelper('get', '/consumer/gift_recommendations'),
}
